import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setModal } from 'slices/modal'
import { setDrawer, setDrawerAlert } from 'slices/drawer'
import { useFirebaseEvent } from 'hooks'
import { STATICS } from 'statics'
import { sendWhatsappMessage, downloadFromUrl } from 'utils'
import { EVENT_STATUS, FIREBASE_EVENTS, MODAL_KEYS, UNDUE_PAYMENT_DOCUMENT_URL } from 'app-constants'
import { Button } from 'components'
import { QUESTIONS } from '../../constants'
import './style.scss'

export function UnduePaymentInitial() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const [loadingDownload, setLoadingDownload] = useState(false)

  function handleOpenFileUploadModal() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_SEND_UNDUE_PAYMENT_FORM)
    dispatch(setDrawer(''))
    dispatch(setModal({ key: MODAL_KEYS.FILE_UPLOAD, data: { isUnduePayment: true } }))
  }

  async function handleFileDownload() {
    setLoadingDownload(true)
    try {
      await downloadFromUrl(UNDUE_PAYMENT_DOCUMENT_URL)
      sendEvent(FIREBASE_EVENTS.CLICK_ON_DOWNLOAD_UNDUE_PAYMENT_FORM)
    } catch (error) {
      console.error(error)
      sendEvent(FIREBASE_EVENTS.CLICK_ON_DOWNLOAD_UNDUE_PAYMENT_FORM, EVENT_STATUS.ERROR)
      dispatch(setDrawerAlert({ severity: 'error', title: "Não foi possível realizar o download, tente novamente mais tarde." }))
    } finally {
      setLoadingDownload(false)
    }
  }

  function handleTalkWithAttendant() {
    sendWhatsappMessage({})
  }

  function renderListItemStep(items) {
    return items.map((item, index) => <li key={index} className='step'>{item}</li>)
  }

  function renderListSteps(items = []) {
    if (!items.length) return null

    return <ol className='list-steps'>{renderListItemStep(items)}</ol>
  }

  function renderListItems() {
    return QUESTIONS.map(({ text, title, items }, index) => (
      <li key={index} className='list-item'>
        <div className='list-item-content'>
          <span className='title'>{title}</span>
          <span className='text'>{text}</span>
          {renderListSteps(items)}
        </div>
      </li>
    ))
  }

  return (
    <div className='container-undue-payment'>
      <div className='container-info'>
        <span className='title'>Corrigir pagamento indevido</span>
        <div className='container-question'>
          <span className='text'>
            <strong>Pagou a fatura de outro cliente por engano?</strong>
          </span>
          <span className='text'>Fica tranquilo! Veja como regularizar:</span>
        </div>
        <div className='container-info'>
          <span className='title'>Siga o passo a passo para solicitar o ajuste</span>
          <ol className='questions-list'>{renderListItems()}</ol>
        </div>
        <div className='container-warning'>
          <div className='container-title'>
            <STATICS.INFO_OUTLINE />
            <span className='title'>
              <strong>Importante:</strong>
            </span>
          </div>
          <div className='text-holder'>
            <span className='text'>
              O ajuste só será feito após:
              <br /> Recebermos o termo preenchido e assinado;
              <br /> E você falar com a nossa Central.
            </span>
          </div>
        </div>
      </div>
      <div className='container-buttons'>
        <Button className='button' onClick={handleFileDownload} color='primary' isLoading={loadingDownload}>
          Baixar formulário
        </Button>

        <Button onClick={handleOpenFileUploadModal} className='button'>
          Anexar termo assinado
        </Button>
        <Button onClick={handleTalkWithAttendant} className='button'>
          Falar com atendimento
        </Button>
      </div>
    </div>
  )
}
